import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Compass, Sparkles, ClipboardList } from "lucide-react";
import { t } from "../../lib/i18n";

const TABS = [
  { to: "/", label: t("bottomnav.home"), icon: Home, testid: "bnav-home" },
  { to: "/services", label: t("bottomnav.explore"), icon: Compass, testid: "bnav-explore" },
  { to: "/plan", label: t("bottomnav.plan"), icon: Sparkles, testid: "bnav-plan", primary: true },
  { to: "/track", label: t("bottomnav.track"), icon: ClipboardList, testid: "bnav-track" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-[#EAE3D2] bg-[#FAF7F2]/95 backdrop-blur md:hidden"
    >
      <ul className="grid grid-cols-4 px-2 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-2">
        {TABS.map(({ to, label, icon: Icon, testid, primary }) => {
          const active = pathname === to || (to !== "/" && pathname.startsWith(to));
          if (primary) {
            return (
              <li key={to} className="flex justify-center">
                <Link
                  to={to}
                  data-testid={testid}
                  className="flex min-h-[44px] -mt-6 items-center gap-2 rounded-full bg-[#C8A24B] px-5 text-xs uppercase tracking-[0.18em] text-[#1A1A1A] shadow-sm transition hover:bg-[#b89039]"
                  aria-current={active ? "page" : undefined}
                >
                  <Icon className="h-4 w-4" />
                  {label}
                </Link>
              </li>
            );
          }
          return (
            <li key={to}>
              <Link
                to={to}
                data-testid={testid}
                aria-current={active ? "page" : undefined}
                className={[
                  "flex min-h-[44px] flex-col items-center justify-center gap-0.5 text-[10px] uppercase tracking-[0.18em] transition",
                  active ? "text-[#1A1A1A]" : "text-[#1A1A1A]/50 hover:text-[#1A1A1A]",
                ].join(" ")}
              >
                <Icon className="h-5 w-5" />
                {label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
